import { useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import { Button, Stack, Typography } from '@mui/material'

const BookADemo = () => {

    const navigate = useNavigate();
    const languageStrs = useSelector((store) => store.editdata.languageStrs)

    return (
        <Stack
            flexDirection={{ xs: 'column', md: 'row' }}
            justifyContent={"space-evenly"}
            sx={{ background: "linear-gradient(to right,#CD3235, #AA26BE)", margin: "4% 5%", marginTop: "-15%" }}
            alignItems={"center"}
            padding={"2% 3%"}
        >
            <Typography
                sx={{
                    fontSize: { xs: '0.8rem', sm: '1rem', md: '1.5rem', lg: '2rem', xl: '2.5rem' },
                    maxWidth: "28ch",
                    fontWeight: 600,
                    color: "#E0E0E0",
                }}
            >
                {languageStrs.finish_post_production}
            </Typography>

            <Button
                onClick={() => navigate('/dashboard/templates')}
                className='upscaleTransition'
                sx={{
                    padding: '0 2rem',
                    borderRadius: 0,
                    flexDirection: 'column',
                    backgroundColor: "#F5F5F5",
                    //background: "linear-gradient(to right,#CD3235, #AA26BE)",
                    marginBottom: '1.5rem',
                }}
            >
                <Typography
                    sx={{
                        color: "#474747",
                        fontSize: { xs: '0.8rem', sm: '1.2rem', md: '1.5rem', lg: '2rem', xl: '2.5rem' },
                        fontWeight: 700,
                    }}
                >
                    {languageStrs.try_now}
                </Typography>
            </Button>
        </Stack>
    )
}

export default BookADemo